import _ from "lodash";
import React from "react";
import { IonIcon } from "@ionic/react";
import { homeOutline, chevronForward } from "ionicons/icons";

import styled from "styled-components";
const Container = styled.div`
  margin-top: 4px;
  padding: 4px 20px 4px 20px;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background: #2eacb4;
`;
const PathItem = styled.div`
  color: #f4f5f8;
  cursor: pointer;
  :hover {
    color: #d7d8da;
  }
  font-size: 0.9em;
  font-weight: bold;
`;
const PathDivider = styled(IonIcon)`
  color: #54d0d5;
`;
// const HomeIcon = styled(IonIcon)`
//   color: #f4f5f8;
//   cursor: pointer;
//   :hover {
//     color: #d7d8da;
//   }
// `;

const AppBreadcrumb = (props) => {
  const breadcrumbContent = [];
  _.get(props, "breadcrumbPath", []).forEach((p, index) => {
    if (index === 0) {
      breadcrumbContent.push(
        // <HomeIcon
        //   icon={homeOutline}
        //   onClick={() => {
        //     props.history.push("/groups");
        //   }}
        //   key={"home"}
        // />
        <PathItem
          icon={homeOutline}
          onClick={() => {
            props.history.push("/groups");
          }}
          key={"home"}
        >
          HOME
        </PathItem>
      );
    }

    // if (index > 0) {
    breadcrumbContent.push(
      <PathDivider icon={chevronForward} key={index + "_divider"} />
    );
    // }

    breadcrumbContent.push(
      <PathItem
        key={index}
        onClick={() => {
          props.history.push(_.get(p, "url"));
        }}
      >
        {_.get(p, "label", "").toUpperCase()}
      </PathItem>
    );
  });

  return <Container>{breadcrumbContent}</Container>;
};

export default AppBreadcrumb;
